import { useEffect, useState } from "react";
import { getDashboardStats } from "../../service/AdminService/adminDashboardService";
import { getRecentBundle, getRecentCourse, getRecentCoursesAndBundles, getRecentGroups, getRecentUser } from "../../service/AdminService/adminDashboardService";

export const useAdminDashboard = () => {
    const [stats, setStats] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const [userCount, setUserCount] = useState(0);
    const [courseCount, setCourseCount] = useState(0);
    const [bundleCount, setBundleCount] = useState(0);
    const [groupCount, setGroupCount] = useState(0);
    const [enrollmentCount, setEnrollmentCount] = useState(0);
    const [activeUsers, setActiveUsers] = useState(5);
    const [stalledProgress, setStalledProgress] = useState(10); 
    const [activeDomainCount, setActiveDomainCount] = useState(0);
    const [recentUserList, setRecentUserList] = useState([]);
    const [recentCourseList, setRecentCourseList] = useState([]);
    const [recentBundleList, setRecentBundleList] = useState([]);
    const [recentGroupList, setRecentGroupList] = useState([]);
    

    const fetchStats = async () => {
            try {
                setLoading(true);
                const data = await getDashboardStats();
                setUserCount(data.userCount);
                setCourseCount(data.courseCount);
                setActiveDomainCount(data.activeDomainCount);
                setBundleCount(data.bundleCount);
                setGroupCount(data.groupCount);
                setEnrollmentCount(data.totalEnrollments);
                setStats(data);
                setError(null);
            } catch (err) {
                console.error(err);
                setError(err);
            } finally {
                setLoading(false);
            }
        };

     const fetchRecentUser = async () => {
       setLoading(true);
        try {
          const response = await getRecentUser();
          setRecentUserList(response);
        } catch (error) {
          console.error("Error fetching recent users:", error);
        }finally{
          setLoading(false);
        }
      };
    
      const fetchRecentCourse = async () => {
        setLoading(true);
        try {
          const response = await getRecentCourse();
          setRecentCourseList(response);
        } catch (error) {
          console.error("Error fetching recent courses:", error);
        }finally{
          setLoading(false);
        }
      };
    
      const fetchRecentBundle = async () => {
        setLoading(true);
        try {
          const response = await getRecentBundle();
          setRecentBundleList(response);
        } catch (error) {
          console.error("Error fetching recent bundles:", error);
        }finally{
          setLoading(false);
        }
      };
    
      const fetchRecentGroup = async () => {
        setLoading(true);
        try {
          const response = await getRecentGroups();
          setRecentGroupList(response);
        } catch (error) {
          console.error("Error fetching recent groups:", error);
        }finally{
          setLoading(false);
        }
      };

    useEffect(() => {
        fetchStats();
        fetchRecentUser();
        fetchRecentCourse();
        fetchRecentBundle();
        fetchRecentGroup();
    }, []);

    return {
        userCount,
        bundleCount,
        courseCount,
        activeDomainCount,
        groupCount,
        enrollmentCount,
        recentUserList,
        recentGroupList,
        recentCourseList,
        recentBundleList,
        stats,
        loading,
        error,
        refetch: fetchStats,
    }
}